<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'new-evaluation.role-assignment'">Asignación de roles
    </span>
  </div>
  <!-- Contenedor -->
  <div class="common-modal__content common-modal__content-scroll">
    <p class="common-modal__content-header-info"
      [afTranslate]="'role-assignment-modal.info-header'">_Selecciona un usuario y decide si quieres que desempeñe el rol sobre todas las organizaciones a las que tiene permiso de acceso o solo sobre una selección de ellas.</p>
    <div class="common-modal__form-container">
      <div class="common-container__mandatory-obligatory-message-form">
        <span class="common-tag__mandatory-text-asterisk">*</span>
        <span class="common-tag__mandatory-label-text-obligatory-message"
          [afTranslate]="'common.required-fields'">_Campos obligatorios</span>
      </div>
      <field-type-contacts
        [field]="roleAssignmentModal.userRoleField"
        [valueId]="configuration.productId"
        (sendContacts)="receiveContacts($event.contacts)">
      </field-type-contacts>
      <field-type-list-multiple [field]="roleAssignmentModal.organizationsField"
        [listValues]="roleAssignmentModal.clientsList"
        [preSelectItem]="roleAssignmentModal.clientsSelected"
        [orderBy]="'numOrder'"
        (itemSelected)="clientSelected($event)">
      </field-type-list-multiple>
    </div>
  </div>
  <div class="common-modal__footer">
    <button class="common-button__text-border"
      (click)="handleDismiss()">
      <span class="common-button__text-title"
        [afTranslate]="'common.cancel'">_Cancelar
      </span>
    </button>
    <button class="common-button__text"
      (click)="validateFields()">
      <span class="common-button__text-title"
        [afTranslate]="'add-assignment.assign'">_Asignar
      </span>
    </button>
  </div>
</div>
